<div class="app-loader" role="status" aria-live="polite">
  <div class="loader-card">
    <div class="spinner"></div>
    <div class="loader-text"> {{ "Loading..." | transloco }} </div>
  </div>
</div>